import { AuthenticationResultDTO, Claim } from 'src/services/generated/api.generated.v1';
import { MutationTree } from 'vuex';
import { UserStateInterface } from './state';
import { ClaimTypes, DealerRoles } from '../../constants/ClaimTypes';
import { ClaimHelper } from 'src/utils';

const mutation: MutationTree<UserStateInterface> = {
  updateUserState(state: UserStateInterface, authResult: AuthenticationResultDTO) {
    state.id = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.NAME_IDENTIFIER);
    state.email = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.EMAIL);
    state.firstName = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.FIRST_NAME);
    state.lastName = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.SURNAME);
    state.phoneNumber = ClaimHelper.GetClaimValue(authResult?.claims, ClaimTypes.OTHER_PHONE);
    state.permissions = ClaimHelper.GetClaimValues(authResult?.claims, ClaimTypes.PERMISSION);
    state.dealerRoles = ClaimHelper.GetClaimValues(authResult?.claims, ClaimTypes.DEALER_ROLE);

    state.dealers = getDealerClaims(authResult?.claims);
    state.activeDealerAccountUid = state.dealers.length > 0 ? state.activeDealerAccountUid ?? state.dealers[0].dealerAccountUid : null;
    state.hasFullRights = (state.dealerRoles.includes(DealerRoles.DealerAdmin) && onlyHasOneLocation(state)) || state.dealerRoles.includes(DealerRoles.DealerSuperAdmin);
  },  
  updateActiveDealerAccount(state: UserStateInterface, dealerUid: string) {
    state.activeDealerAccountUid = dealerUid;
  }
}

function getDealerClaims(claims: Array<Claim> | null | undefined) {
  const getDealerName = (props: { [key: string]: string; } | null | undefined) => props ? props['Name'] : '';
  const getIsChainGroup = (props: { [key: string]: string; } | null | undefined) => props ? props['IsChainGroup'] === 'True' : false;

  const dealers = ClaimHelper.GetClaims(claims, ClaimTypes.DEALER_ACCOUNT)
    .map(x => ({
      dealerAccountUid: <string>x.value,
      permissions: ClaimHelper.GetClaimValues(claims, `${ClaimTypes.DEALER_PERMISSION}/${<string>x.value}`),
      dealerName: getDealerName(x.properties),
      isChainGroup: getIsChainGroup(x.properties),
    }));

  return dealers ?? [];
}

function onlyHasOneLocation(state: UserStateInterface) : boolean {
  return state.dealers.length == 1 && !state.dealers.some(x => x.isChainGroup);
}

export default mutation;